export const PUBLIC_ROUTES = {
  BLANK: "",
  NOT_FOUND: "/404",
  MAINTENANCE: "/maintenance",
  FOR_BIDDEN: "/403",
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
};

export enum PageRouter {
  Chargeback = "/admin/chargeback",
  ChargebackManagement = "/admin/chargeback-management",
  DisbursementReport = "/admin/payouts",
  PayoutManagement = "/admin/payout-management",
  NewPayout = "/admin/new-payout",
  OnboardingManagement = "/admin/onboarding-management",
  partnerSettings = "/admin/partner-setting",
  Onboarding = "/admin/onboarding",
  OnboardingSettings = "/admin/onboarding-settings",
  CommunicationSetting = "/admin/communication-setting",
  CrossCheck = "/admin/cross-check",
  AdminPayment = "/admin/admin-payment",
  PSPManagement = "/admin/psp-management",
}
